import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";



export function useProfileApi() {
  const callApi = useApiCall();

  const profileUpdate = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.PROFILE.UPDATE, data, onSuccess, onError);
  }; 


  return {
    profileUpdate, 
  };
}
